import React, {useEffect} from 'react'
import AudioPlayer from 'react-h5-audio-player';
import music1 from '../../img/startAndFinal.mp3'
import musicGame1 from '../../img/game1.mp3'
import musicGame2 from '../../img/game2.mp3'
import musicGame3 from '../../img/game3.mp3'
import musicGame4 from '../../img/game4.mp3'
import musicGame5 from '../../img/game5.mp3'
import musicGame6 from '../../img/game6.mp3'
import './Music.scss'


function Menu ({
	isRouteTraveled,
	isPlayMusic,
	musicPlayer,
	meadowPage,
	waterfallPage,
	trailPage,
	peaksPage,
	campPage,
	mountainPage,
	finalPage,
}){



	const gameStarted = () => {
		if(isRouteTraveled?.includes(finalPage)) return music1
		if(isRouteTraveled?.includes(mountainPage)) return musicGame6
		if(isRouteTraveled?.includes(campPage)) return musicGame5
		if(isRouteTraveled?.includes(peaksPage)) return musicGame4
		if(isRouteTraveled?.includes(trailPage)) return musicGame3
		if(isRouteTraveled?.includes(waterfallPage)) return musicGame2
		if(isRouteTraveled?.includes(meadowPage)) return musicGame1
		//if(isRouteTraveled?.includes('')) return music1
		else return music1
	}


/*	useEffect(() => {
		if(isPlayMusic === true) {
			gameStarted()
		}
	}, [isRouteTraveled])*/

	return (
		<div className='music'>
			<AudioPlayer
				ref={musicPlayer}
				src={isPlayMusic === true ? gameStarted() : ''}
				loop={true}
				onPlay={isPlayMusic}
				//onPause={isPlayMusic}
			/>
		</div>
	)
}

export default Menu